import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const GridViewContext = createContext();

// Create a custom hook to use the context
export function useGridView() {
  return useContext(GridViewContext);
}

// Create the context provider component
export function GridViewProvider({ children }) {
  const [isGridView, setIsGridView] = useState(false);

  useEffect(() => {
    const storedIsGridView = localStorage.getItem('isGridView');
    if (storedIsGridView !== null) {
      setIsGridView(storedIsGridView === 'true');
    } else {
      setIsGridView(false);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('isGridView', isGridView);
  }, [isGridView]);

  const toggleView = () => {
    setIsGridView(prevIsGridView => !prevIsGridView);
  };

  return (
    <GridViewContext.Provider value={{ isGridView, toggleView }}>
      {children}
    </GridViewContext.Provider>
  );
}
